import { gql } from "@apollo/client";

export const CONFIRMAR_EQUIPO = gql`
mutation addConfirmarEquipo(
    $idEvaluacion: Int!,
    $addConfirmarEquipoItems: [AddConfirmarEquipoItemInput!]!
) {
    addConfirmarEquipo(
        input: {
            idEvaluacion: $idEvaluacion
            addConfirmarEquipoItems: $addConfirmarEquipoItems
        }
    ) 
}`;